const postTypes = {
    ThoughtLeadership: "Thought Leadership",
    IndustryEvents: "Industry Events",
    CaseStudies: "Case Studies",
    CompanyHighlights: "Company Highlights",
    Press: "Press"
};

export default postTypes;